import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { TRANSLATIONS, LANGUAGES } from "./translations";

const LanguageContext = createContext({
  lang: "nl",
  setLang: () => {},
  t: (k) => k,
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try {
      return localStorage.getItem("janmobile_lang") || "nl";
    } catch {
      // localStorage unavailable (SSR / private browsing) - fall back to default
      return "nl";
    }
  });

  const setLang = (l) => {
    setLangState(l);
    try {
      localStorage.setItem("janmobile_lang", l);
    } catch {
      // localStorage unavailable - state still updates in-memory for current session
    }
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(() => {
    const dict = TRANSLATIONS[lang] || TRANSLATIONS.nl;
    const t = (key) => dict[key] ?? TRANSLATIONS.nl[key] ?? key;
    return { lang, setLang, t, languages: LANGUAGES };
  }, [lang]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
